import React, { useEffect } from 'react';
import styles from './localizacoes_amandacgazoni.module.scss';
import { FaArrowLeft, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const locations = [
    {
        name: "Barretos",
        address: "R. Argentina, 2406 - América, Barretos - SP, 14783-192",
        coordinates: "https://maps.app.goo.gl/1MhM26SDNgz77AfA6",
        note: ""
    },
    {
        name: "Guaraci",
        address: "R. Washington Corrêa da Silva, 743 - Centro, Guaraci - SP, 15420-000",
        coordinates: "https://maps.app.goo.gl/z1u6V5xgBLDE4F3M6",
        note: "Atendimento aos sábados"
    }
];

const Localizacoes_amandacgazoni: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.localizacoes_amandacgazoni}>
            <div className={styles.header}>
                <Link to="/amandacgazoni" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1>Localizações</h1>
            </div>

            <div className={styles.cardsContainer}>
                {locations.map((location, index) => (
                    <div key={index} className={styles.locationCard}>
                        <div className={styles.locationHeader}>
                            <FaMapMarkerAlt className={styles.icon} />
                            <h3>{location.name}</h3>
                        </div>
                         {location.note && (
                            <span className={styles.noteTag}>{location.note}</span>
                        )}
                        <p className={styles.address}>{location.address}</p>
                        <a
                            href={location.coordinates}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.mapButton}
                        >
                            Ver no mapa
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Localizacoes_amandacgazoni;
